module.exports = __webpack_public_path__ + "img/arrow-left.d3110d13.svg";